import PageMeta from "../../components/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import SignInForm from "../../components/auth/SignInForm";

const SignIn = () => {
  return (
    <>
      <PageMeta
        title="Free QR code for cafe, restaurant and bar | GetEat"
        description="This is GetEat SignIn page, where you can create you own QR code menu for your restaurant, cafe or bar. Sign in to your account and start creating your menu."
      />
      <AuthLayout>
        <SignInForm />
      </AuthLayout>
    </>
  );
}

export default SignIn;

